import { render, staticRenderFns } from "./Prop65ComplianceComponent.vue?vue&type=template&id=60f48101&scoped=true&"
import script from "./Prop65ComplianceComponent.vue?vue&type=script&lang=js&"
export * from "./Prop65ComplianceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f48101",
  null
  
)

export default component.exports